<template>
  <v-form ref="form" autocomplete="off">
    <v-row dense>

      <v-col cols="12" v-if="enableLocalityCombobox">
        <locality-combobox
            v-model="form.localityFilter"
            default-first
            item-value="locality"
            :hide-details="dense"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        />
      </v-col>

      <v-col cols="12" :sm="addressSmCol">

        <address-autocomplete
            :prepend-icon="dense ? null : 'location_on'"
            :prepend-inner-icon="dense ? 'location_on' : null"
            :value="form.address"
            :locality-filter="form.localityFilter"

            :hint="addressHint"
            @input="(val) => (form.address = val)"
            @lat="(val) => (form.latitude = val)"
            @lng="(val) => (form.longitude = val)"
            @country="(val) => (form.country = val)"
            @postalCode="(val) => (form.postalCode = val)"
            @province="(val) => (form.province = val)"
            @locality="(val) => (form.locality = val)"
            @place_id="(val) => (form.place_id = val)"
            @clear="$emit('clear')"
            @change="forceRerenderLocationMap"

            :single-line="dense"
            :dense="dense"
            :outlined="dense"
            mandatory mandatory-number
        ></address-autocomplete>
      </v-col>


      <v-col v-if="enableFloor" cols="6" :sm="apartmentSmCol">
        <v-text-field
            v-if="!addressFirst || form.address"

            :prepend-icon="dense ? null : 'apartment'"
            :prepend-inner-icon="dense ? 'apartment' : null"
            name="floor"
            v-model="form.floor"
            :label="$t('maps.location.labels.floor')"
            :error="hasInputErrors('floor')"
            :error-messages="getInputErrors('floor')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
            hide-details
        ></v-text-field>
      </v-col>


      <v-col v-if="enableApartment" cols="6" :sm="floorSmCol">
        <v-text-field
            v-if="!addressFirst || form.address"
            :prepend-icon="dense ? null : 'meeting_room'"
            :prepend-inner-icon="dense ? 'meeting_room' : null"
            name="apartment"
            v-model="form.apartment"
            :label="$t('maps.location.labels.apartment')"
            :error="hasInputErrors('apartment')"
            :error-messages="getInputErrors('apartment')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
            hide-details
        ></v-text-field>
      </v-col>


      <v-col v-if="enableCoordinates" cols="12" sm="3">
        <v-text-field

            prepend-icon="explore"
            name="latitude"
            v-model.number="form.latitude"
            type="number"
            :label="$t('maps.location.labels.latitude')"
            :error="hasInputErrors('latitude')"
            :error-messages="getInputErrors('latitude')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>


      <v-col v-if="enableCoordinates" cols="12" sm="3">
        <v-text-field

            prepend-icon="explore"
            name="longitude"
            v-model.number="form.longitude"
            type="number"
            :label="$t('maps.location.labels.longitude')"
            :error="hasInputErrors('longitude')"
            :error-messages="getInputErrors('longitude')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>


      <v-col v-if="enableCountry" cols="12" sm="6">
        <v-text-field

            prepend-icon="flag"
            name="country"
            v-model="form.country"
            :label="$t('maps.location.labels.country')"
            :error="hasInputErrors('country')"
            :error-messages="getInputErrors('country')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>


      <v-col v-if="enableProvince" cols="12" sm="4">
        <v-text-field

            prepend-icon="villa"
            name="province"
            v-model="form.province"
            :label="$t('maps.location.labels.province')"
            :error="hasInputErrors('province')"
            :error-messages="getInputErrors('province')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>


      <v-col v-if="enableLocality" cols="12" sm="4">
        <v-text-field

            prepend-icon="location_city"
            name="locality"
            v-model="form.locality"
            :label="$t('maps.location.labels.locality')"
            :error="hasInputErrors('locality')"
            :error-messages="getInputErrors('locality')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>


      <v-col v-if="enablePostalCode" cols="12" sm="4">
        <v-text-field

            prepend-icon="local_shipping"
            name="postalCode"
            v-model="form.postalCode"
            :label="$t('maps.location.labels.postalCode')"
            :error="hasInputErrors('postalCode')"
            :error-messages="getInputErrors('postalCode')"
            color="secondary"
            :single-line="dense"
            :dense="dense"
            :outlined="dense"
        ></v-text-field>
      </v-col>
    </v-row>


    <v-row align="center" justify="center">
      <v-col v-if="enableMap" cols="12" :sm="mapSmCol">
        <location-map
            v-if="form.latitude && form.longitude"
            :key="locationMapKey"
            v-model="form"
            :height="mapHeight"
        ></location-map>
      </v-col>

      <v-col v-if="enableStreetView" cols="12" sm="3">
        <street-view-image v-if="form.latitude && form.longitude"
                           :latitude="form.latitude"
                           :longitude="form.longitude"
        >

        </street-view-image>
      </v-col>

      <v-col v-if="enableZone" cols="12" sm="3" class="text-center">
        <v-card>
          <zones-point
              v-if="form.latitude && form.longitude"
              :latitude="form.latitude"
              :longitude="form.longitude"
          ></zones-point>
        </v-card>

      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import AddressAutocomplete from "@/modules/maps/components/AddressAutocomplete/AddressAutocomplete";
import LocationMap from "@/modules/maps/components/LocationMap/LocationMap";
import StreetViewImage from "@/modules/maps/components/StreetViewImage/StreetViewImage";
import ZonesPoint from "@/modules/maps/components/ZonesPoint/ZonesPoint";
import LocalityCombobox from "@/modules/maps/components/LocalityCombobox/LocalityCombobox";


export default {
  name: "LocationForm",
  components: {LocalityCombobox, ZonesPoint, StreetViewImage, LocationMap, AddressAutocomplete},
  mixins: [InputErrorsByProps, RequiredRule],

  props: {
    value: {type: Object, required: true},
    addressFirst: {type: Boolean, default: false},
    addressSmCol: {type: Number, default: 6},
    apartmentSmCol: {type: Number, default: 3},
    floorSmCol: {type: Number, default: 3},
    mapSmCol: {type: Number, default: 6},
    addressHint: {type: String},
    enableLocalityCombobox: {type: Boolean, default: false},
    enableCoordinates: {type: Boolean, default: false},
    enableCountry: {type: Boolean, default: false},
    enableLocality: {type: Boolean, default: false},
    enableProvince: {type: Boolean, default: false},
    enablePostalCode: {type: Boolean, default: false},
    enableFloor: {type: Boolean, default: false},
    enableApartment: {type: Boolean, default: false},
    enableMap: {type: Boolean, default: false},
    mapHeight: {type: String, default: '300px'},
    enableStreetView: {type: Boolean, default: false},
    enableZone: {type: Boolean, default: false},
    dense: {type: Boolean, default: false},
  },
  data() {
    return {
      locality: null,
      locationMapKey: 0
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    forceRerenderLocationMap() {
      this.locationMapKey++
    }
  },

}
</script>

<style scoped>

</style>

